var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "description",
                    label: "版本更新内容",
                  },
                },
                [
                  _c("a-textarea", {
                    attrs: { placeholder: "请输入版本更新内容" },
                    model: {
                      value: _vm.model.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "description", $$v)
                      },
                      expression: "model.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionUrl",
                    label: "请上传更新文件",
                  },
                },
                [
                  _c(
                    "a-upload",
                    {
                      attrs: {
                        maxCount: 1,
                        action: _vm.apiBaseUrl + "/sys/common/upload",
                        data: {
                          biz: "aigoes-ai-school/upgradePack",
                          bucket: "aigoes-public",
                        },
                        headers: { "X-Access-Token": _vm.token },
                        accept: "wgt,ipa, apk",
                      },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.fileList,
                        callback: function ($$v) {
                          _vm.fileList = $$v
                        },
                        expression: "fileList",
                      },
                    },
                    [_c("a-button", [_vm._v(" Upload ")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionForce",
                    label: "是否强制更新",
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.model.editionForce,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "editionForce", $$v)
                        },
                        expression: "model.editionForce",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: 1 } }, [_vm._v("是")]),
                      _c("a-radio", { attrs: { value: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "packageType",
                    label: "是否真整包升级",
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.model.packageType,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "packageType", $$v)
                        },
                        expression: "model.packageType",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: 1 } }, [
                        _vm._v("否(wgt升级)"),
                      ]),
                      _c("a-radio", { attrs: { value: 0 } }, [_vm._v("是")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionIssue",
                    label: "是否发行",
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.model.editionIssue,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "editionIssue", $$v)
                        },
                        expression: "model.editionIssue",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: 1 } }, [_vm._v("是")]),
                      _c("a-radio", { attrs: { value: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionNumber",
                    label: "版本号",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.editionNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionNumber", $$v)
                      },
                      expression: "model.editionNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionName",
                    label: "版本名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入版本名称 manifest里的版本名称",
                    },
                    model: {
                      value: _vm.model.editionName,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionName", $$v)
                      },
                      expression: "model.editionName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionSilence",
                    label: "是否静默更新",
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.model.editionSilence,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "editionSilence", $$v)
                        },
                        expression: "model.editionSilence",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: 1 } }, [_vm._v("是")]),
                      _c("a-radio", { attrs: { value: 0 } }, [_vm._v("否")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }